import axios from "axios";
import { Urls } from "../../store/urls";

export const getJobListingRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_POST_JOB_LISTING_API,
        params: params,
    });
};

export const getDepartmentsRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_DEPARTMENTS_API,
        params: params,
    });
};

export const getUserListRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_USERS_LIST_API,
        params: params,
    });
};

export const getJobBasicDetailRepo = (id, params) => {
    return axios({
        method: "GET",
        url: Urls.GET_PUT_JOB_BASIC_DETAIL_API + "/" + id,
        params: params,
    });
};

export const putJobBasicDetailRepo = (id, data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_PUT_JOB_BASIC_DETAIL_API + "/" + id,
        data: data,
    });
};

export const getStaticContentRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.EDIT_STATIC_CONTENT_API,
        params: params,
    });
};

export const putStaticContentRepo = (data) => {
    return axios({
        method: "PUT",
        url: Urls.EDIT_STATIC_CONTENT_API,
        data: data,
    });
};

export const postBasicJobDetailsRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.GET_POST_JOB_LISTING_API,
        data: data,
    });
};

export const getJobLocationRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_JOB_LOCATION_API,
        params: params,
    });
};

export const getApplicantListRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_APPLICANT_LIST_API,
        params: params,
    });
};

export const getApplicantFiltersRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_APPLICANT_FILTERS_API,
        params: params,
    });
};

export const getApplicantRepo = (id, params) => {
    return axios({
        method: "GET",
        url: Urls.GET_APPLICANT_API + "/" + id,
        params: params,
    });
};

export const getDownloadApplicantListRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_DOWNLOAD_APPLICANT_LIST_API,
        params: params,
    });
};

export const putApplicantCommentsRepo = (id, data) => {
    return axios({
        method: "PUT",
        url: Urls.GET_APPLICANT_API + "/" + id,
        data: data
    });
};

export const getApplicantFlushDataRepo = () => {
    return axios({
        method: "GET",
        url: Urls.GET_FLUSH_APPLICANT_DATA,
    });
};